// extracted by mini-css-extract-plugin
export var link = "_va-0";